// This should ideally be replaced by typings/sort, but enums are unable
//     to be imported currently as it they outside of the src directory.
//     TTPSP-404
export enum SortDirections {
    ASC = "asc",
    DESC = "desc"
}

export const toggleSortDirection = (
    setDirection: React.Dispatch<React.SetStateAction<SortDirections>>,
    activeDirection: SortDirections
): void => {
    if (activeDirection === SortDirections.ASC) setDirection(SortDirections.DESC)
    else setDirection(SortDirections.ASC)
}
